import projectAll from "./project.js"
const getConfig = (name) => {
    //可能存在没有项目标识的  如果没有则返回
    if(process.argv.project&&name){
        return projectAll[process.argv.project][name]
    }else{
        return projectAll
    }
}
export {
    getConfig,
}